export const TERMS_AND_CONDITIONS_SETTING_NAME = "Accepted Terms Version";
export const TERMS_AND_CONDITIONS_VERSION = "2026-04-employment-rights-act-2025";
export const TERMS_AND_CONDITIONS_FILE_NAME = "TRICS Licence Terms & Conditions";
export const TERMS_AND_CONDITIONS_URL = "/documents/trics-user-licence-agreement-terms-and-conditions-apr-2026.pdf";
export const TERMS_AND_CONDITIONS_UPDATE_MESSAGE = "The TRICS Licence Terms & Conditions have been updated, with paragraph 4.6 inserted due to changes in government legislation (the Employment Rights Act 2025). This is the only revision, and the document can be viewed using the link below prior to clicking Accept.";

export function openTermsAndConditions() {
    const newTab = window.open(TERMS_AND_CONDITIONS_URL, "_blank", "noopener,noreferrer");

    if (newTab) {
        newTab.opener = null;
    }
}
